exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".q-edit-content[data-v-3630a085] {\n  width: 100%;\n  margin-top: 10px;\n  position: relative;\n}\n.q-edit-content[data-v-3630a085]  .com-input.code {\n    margin-top: 5px;\n    width: 60%;\n}\n.q-edit-content[data-v-3630a085]  .com-button {\n    font-size: 12px;\n    padding: 6px 20px;\n}\n.q-edit-content[data-v-3630a085]  .com-button.code {\n      margin-top: 5px;\n      width: 39%;\n      margin-left: 1px;\n}\n.q-edit-content[data-v-3630a085]  .error-msg {\n    position: absolute;\n    color: #fc5659;\n    top: 44px;\n    line-height: 20px;\n    font-size: 12px;\n}\n", ""]);

// exports
